import React from "react";
import LandingHeader from "../../components/LandingComponents/Header";
import HeroSection from "../../components/LandingComponents/HeroSection";
import Benefits from "../../components/LandingComponents/Benefits";
import Footer from "../../components/LandingComponents/Footer";
import DownloadSection from "../../components/LandingComponents/DownloadSection";
import Patnership from "../../components/LandingComponents/Patnership";
import About from "../../components/LandingComponents/About";
import Newsletter from "../../components/LandingComponents/Newletter";

function LandingPage(){
    return(
        <div>
            
            <LandingHeader />
            <HeroSection />
            <Benefits />
            <DownloadSection/>
            <Patnership/>
            <About/>
            <Newsletter/>
            <Footer />
        </div>
    )
}

export default LandingPage;